// import BackgroundSlide from './BackgroundSlide'
// import BgEffectAnimation from './BgEffectAnimation'
// import PersonSlide from './PersonSlide'
// import MovieController from './MovieController'
// import ImageChange from './ImageChange'
import HeroSlider from './HeroSlider'
import HeroCopyAnimation from './HeroCopyAnimation'
import BusinessStackCards from './BusinessStackCards'

export default class {
  constructor() {
    
    const domHeroSlider = document.querySelector('[data-js="hero-slider"]');
    if (domHeroSlider) new HeroSlider(domHeroSlider);

    const domHeroCopy = document.querySelector('.top-hero-copy');
    if (domHeroCopy) new HeroCopyAnimation(domHeroCopy, {
      initialDelay: .6,   // 開始までの待機（秒）
      stagger: 0.12,       // 各行の間隔（秒）
      duration: 0.8,       // 各行のアニメーション時間（秒）
      lines: [             // 各行の個別設定（未指定プロパティはデフォルト値を使用）
        { delay: 0, duration: 0.8, ease: 'power3.out' },
        { delay: 0, duration: 0.8, ease: 'power3.out' },
        { delay: 0, duration: 0.9, ease: 'power3.out' },
      ],
    });

    const domBusinessUnits = document.querySelector('.top-business__units');
    if (domBusinessUnits) new BusinessStackCards(domBusinessUnits);

  }
}
